import * as React from 'react';
import { Spinner } from '@cian/ui-kit';

import * as styles from './BannerLoader.css';

export const BannerLoader: React.FC = () => {
  return (
    <div className={styles['container']}>
      <Spinner size={40} />
    </div>
  );
};
